export function firstSentence(body: string): string {
  return /^.*?[.!?](?=\s|$)/.exec(body)?.[0] ?? body;
}

function firstParagraph(body: string): string {
  return (body.split(/\n\s*\n/)[0] ?? body).trim();
}

const listMarker = /^([-*+]|\d+[.)])\s+/;

function leadingList(body: string): string[] | null {
  const lines = body.replace(/\r\n/g, "\n").split("\n");
  const start = lines.findIndex((line) => line.trim() !== "");

  if (start < 0) return null;

  const items: string[][] = [];

  for (const line of lines.slice(start)) {
    if (listMarker.test(line)) {
      items.push([line]);
      continue;
    }

    const current = items.at(-1);

    if (!current) return null;

    if (!/^\s+\S/.test(line)) break;

    current.push(line);
  }

  return items.length ? items.map((item) => item.join("\n")) : null;
}

export function leadBlock(body: string): string {
  const items = leadingList(body);
  return items ? items.slice(0, 3).join("\n") : firstParagraph(body);
}

export function isRedundantTitle(title: string): boolean {
  return "rules & scoring".includes(title.trim().toLowerCase());
}

export function moduleFileName(name: string): string {
  const slug = name
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");
  return `${slug || "player"}.py`;
}
